// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__1Qsaa","amount":"Amount_amount__2GVTR","tip":"Amount_tip__JT62m","tipHeader":"Amount_tipHeader__2kgQG","tipsWrap":"Amount_tipsWrap__M_QrW"};